import { IApiError } from '@frontend/request';

import {
  ICountryAndDialCode,
  ICountryStoneinnoDetail,
  IPasswordUrlResponse,
  IRegisterParams,
  IResetPasswordParams,
  accountAPI
} from '@aqx-core/common/api/account';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

import { IDemoAccountCreation, IDemoSignUpParams, userAccountAPI } from '../../user-account';

class AccountAPIController {
  public getCountryAndDialCodes = async (callbacks: IAPIControllerCallbacks<ICountryAndDialCode[]>) => {
    try {
      const { result } = await accountAPI.getCountryAndDialCodes();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getStoneinnoCountryAndDialCodes = async (callbacks: IAPIControllerCallbacks<ICountryStoneinnoDetail[]>) => {
    try {
      const { result } = await accountAPI.getStoneinnoCountryAndDialCodes();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public resetPassword = async (params: IResetPasswordParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await accountAPI.resetPassword(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public registerAccount = async (params: IRegisterParams, callbacks: IAPIControllerCallbacks<string>) => {
    try {
      const { result } = await accountAPI.register(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getStoneinnoCountries = async (callbacks: IAPIControllerCallbacks<ICountryStoneinnoDetail[]>) => {
    try {
      const { result } = await accountAPI.stoneinnoCountry();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public fetchAccountDeposit = async (callbacks: IAPIControllerCallbacks<number>) => {
    try {
      const { result } = await accountAPI.getAccountDeposit();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getSignUpDepositDefault = async (callbacks: IAPIControllerCallbacks<number>) => {
    try {
      const { result } = await accountAPI.deposit();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public createDemoAccount = async (
    params: IDemoSignUpParams,
    withAuth: boolean,
    callbacks: IAPIControllerCallbacks<IDemoAccountCreation>
  ) => {
    try {
      const { result } = withAuth
        ? await userAccountAPI.demoSignUpAuthenticated(params)
        : await userAccountAPI.demoSignUp(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public fetchChangePasswordUrl = async (callbacks: IAPIControllerCallbacks<IPasswordUrlResponse>) => {
    try {
      const { result } = await accountAPI.getPasswordUrl();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const accountAPIController = new AccountAPIController();
